import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPageByID } from "../../api/page";
import FullscreenPageBuilder from "../../components/FullscreenPageBuilder";

const AdminPageEdit = () => {
    const [page, setPage] = useState<Page>();
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        if (!params.id) {
            navigate("/admin/pages");
            return;
        }

        getPageByID(params.id)
            .then((page) => {
                setPage(page);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [navigate, params.id]);

    const handleSave = () => {
        // Refresh the page data after save
        if (params.id) {
            getPageByID(params.id)
                .then((page) => {
                    setPage(page);
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    };

    return (
        <>
            {page && <FullscreenPageBuilder page={page} onSave={handleSave} />}
        </>
    );
};

export default AdminPageEdit;
